/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type home_viewer$ref = any;
export type routes_Home_QueryVariables = {||};
export type routes_Home_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: home_viewer$ref
  |}
|};
export type routes_Home_Query = {|
  variables: routes_Home_QueryVariables,
  response: routes_Home_QueryResponse,
|};
*/


/*
query routes_Home_Query {
  viewer {
    ...home_viewer
    id
  }
}

fragment FeatureList_viewer on Customer {
  ...List_viewer
  featured: categories(first: 1, urlSlug: "home-page") {
    edges {
      node {
        id
        name
        products(first: 999) {
          edges {
            node {
              id
              adjacentBanners(first: 99) {
                edges {
                  node {
                    id
                    name
                    placement
                    imageUrl
                    link
                  }
                }
              }
              ...ProductCard_product
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
}

fragment List_viewer on Customer {
  id
  ...ProductCard_viewer
}

fragment ProductCard_product on Product {
  id
  alerts
  name
  type
  configurables(first: 99) {
    edges {
      node {
        id
        type
        discountCode
        name
        model
        secondModel
        sku
        regularPrice
        price
        priceMatch
        sellable
        nonStock
      }
    }
  }
  model
  secondModel
  regularPrice
  price
  priceDrop
  sku
  urlSlug
  freeShipping
  priorityShipping {
    getByDate
  }
  globalFreeShipping
  preorderDate
  backInStockDate
  nonStock
  onlineOnly
  callForPrice
  inStoreOnly
  sellable
  clearance
  discountCode
  brand {
    id
    name
  }
  loyaltyPoints {
    accruing
    dollars
  }
  bonusProducts(first: 999) {
    edges {
      node {
        productId
        productName
        productUrlSlug
        price
        quantity
        optional
        id
      }
    }
  }
  labels(first: 999) {
    edges {
      node {
        id
        imageUrl
        placement
        type
      }
    }
  }
  mainImage {
    id
    thumbnail
  }
}

fragment ProductCard_viewer on Customer {
  id
  freeShippingAmount
}

fragment home_viewer on Customer {
  ...FeatureList_viewer
  cmsPage(urlSlug: "home") {
    title
    urlSlug
    content
    metaDescription
  }
  cmsBanners(first: 999) {
    edges {
      node {
        id
        title
        link
        homeBig
        homeSmall
      }
    }
  }
  cmsCarouselImages(first: 999) {
    edges {
      node {
        id
        title
        link
        main1
        main2
        bg1
        bg2
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 999
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placement",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discountCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "secondModel",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sku",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regularPrice",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellable",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nonStock",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_Home_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "home_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "routes_Home_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "freeShippingAmount",
            "storageKey": null
          },
          {
            "alias": "featured",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              {
                "kind": "Literal",
                "name": "urlSlug",
                "value": "home-page"
              }
            ],
            "concreteType": "CategoryConnection",
            "kind": "LinkedField",
            "name": "categories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": (v2/*: any*/),
                        "concreteType": "ProductConnection",
                        "kind": "LinkedField",
                        "name": "products",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v3/*: any*/),
                                    "concreteType": "AdjacentBannerConnection",
                                    "kind": "LinkedField",
                                    "name": "adjacentBanners",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AdjacentBannerEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AdjacentBanner",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v0/*: any*/),
                                              (v1/*: any*/),
                                              (v4/*: any*/),
                                              (v5/*: any*/),
                                              (v6/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "adjacentBanners(first:99)"
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "alerts",
                                    "storageKey": null
                                  },
                                  (v1/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v3/*: any*/),
                                    "concreteType": "ProductConnection",
                                    "kind": "LinkedField",
                                    "name": "configurables",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v0/*: any*/),
                                              (v7/*: any*/),
                                              (v8/*: any*/),
                                              (v1/*: any*/),
                                              (v9/*: any*/),
                                              (v10/*: any*/),
                                              (v11/*: any*/),
                                              (v12/*: any*/),
                                              (v13/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "priceMatch",
                                                "storageKey": null
                                              },
                                              (v14/*: any*/),
                                              (v15/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "configurables(first:99)"
                                  },
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "priceDrop",
                                    "storageKey": null
                                  },
                                  (v11/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "freeShipping",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PriorityShipping",
                                    "kind": "LinkedField",
                                    "name": "priorityShipping",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "getByDate",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "globalFreeShipping",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "preorderDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "backInStockDate",
                                    "storageKey": null
                                  },
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "onlineOnly",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "callForPrice",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "inStoreOnly",
                                    "storageKey": null
                                  },
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "clearance",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Brand",
                                    "kind": "LinkedField",
                                    "name": "brand",
                                    "plural": false,
                                    "selections": [
                                      (v0/*: any*/),
                                      (v1/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LoyaltyPoints",
                                    "kind": "LinkedField",
                                    "name": "loyaltyPoints",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "accruing",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dollars",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v2/*: any*/),
                                    "concreteType": "BonusProductConnection",
                                    "kind": "LinkedField",
                                    "name": "bonusProducts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BonusProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BonusProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "productId",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "productName",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "productUrlSlug",
                                                "storageKey": null
                                              },
                                              (v13/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "quantity",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "optional",
                                                "storageKey": null
                                              },
                                              (v0/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "bonusProducts(first:999)"
                                  },
                                  {
                                    "alias": null,
                                    "args": (v2/*: any*/),
                                    "concreteType": "LabelConnection",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LabelEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v0/*: any*/),
                                              (v5/*: any*/),
                                              (v4/*: any*/),
                                              (v7/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "labels(first:999)"
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductImage",
                                    "kind": "LinkedField",
                                    "name": "mainImage",
                                    "plural": false,
                                    "selections": [
                                      (v0/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "thumbnail",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "products(first:999)"
                      },
                      {
                        "alias": null,
                        "args": (v2/*: any*/),
                        "filters": null,
                        "handle": "connection",
                        "key": "FeatureList_products",
                        "kind": "LinkedHandle",
                        "name": "products"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "categories(first:1,urlSlug:\"home-page\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "urlSlug",
                "value": "home"
              }
            ],
            "concreteType": "CmsPage",
            "kind": "LinkedField",
            "name": "cmsPage",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "metaDescription",
                "storageKey": null
              }
            ],
            "storageKey": "cmsPage(urlSlug:\"home\")"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "CmsBannerConnection",
            "kind": "LinkedField",
            "name": "cmsBanners",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CmsBannerEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CmsBanner",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v17/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "homeBig",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "homeSmall",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "cmsBanners(first:999)"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "CmsCarouselImageConnection",
            "kind": "LinkedField",
            "name": "cmsCarouselImages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CmsCarouselImageEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CmsCarouselImage",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v17/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "main1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "main2",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bg1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bg2",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "cmsCarouselImages(first:999)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fd8f8e4838faddccbae9d5a75d0fba02",
    "id": null,
    "metadata": {},
    "name": "routes_Home_Query",
    "operationKind": "query",
    "text": "query routes_Home_Query {\n  viewer {\n    ...home_viewer\n    id\n  }\n}\n\nfragment FeatureList_viewer on Customer {\n  ...List_viewer\n  featured: categories(first: 1, urlSlug: \"home-page\") {\n    edges {\n      node {\n        id\n        name\n        products(first: 999) {\n          edges {\n            node {\n              id\n              adjacentBanners(first: 99) {\n                edges {\n                  node {\n                    id\n                    name\n                    placement\n                    imageUrl\n                    link\n                  }\n                }\n              }\n              ...ProductCard_product\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment List_viewer on Customer {\n  id\n  ...ProductCard_viewer\n}\n\nfragment ProductCard_product on Product {\n  id\n  alerts\n  name\n  type\n  configurables(first: 99) {\n    edges {\n      node {\n        id\n        type\n        discountCode\n        name\n        model\n        secondModel\n        sku\n        regularPrice\n        price\n        priceMatch\n        sellable\n        nonStock\n      }\n    }\n  }\n  model\n  secondModel\n  regularPrice\n  price\n  priceDrop\n  sku\n  urlSlug\n  freeShipping\n  priorityShipping {\n    getByDate\n  }\n  globalFreeShipping\n  preorderDate\n  backInStockDate\n  nonStock\n  onlineOnly\n  callForPrice\n  inStoreOnly\n  sellable\n  clearance\n  discountCode\n  brand {\n    id\n    name\n  }\n  loyaltyPoints {\n    accruing\n    dollars\n  }\n  bonusProducts(first: 999) {\n    edges {\n      node {\n        productId\n        productName\n        productUrlSlug\n        price\n        quantity\n        optional\n        id\n      }\n    }\n  }\n  labels(first: 999) {\n    edges {\n      node {\n        id\n        imageUrl\n        placement\n        type\n      }\n    }\n  }\n  mainImage {\n    id\n    thumbnail\n  }\n}\n\nfragment ProductCard_viewer on Customer {\n  id\n  freeShippingAmount\n}\n\nfragment home_viewer on Customer {\n  ...FeatureList_viewer\n  cmsPage(urlSlug: \"home\") {\n    title\n    urlSlug\n    content\n    metaDescription\n  }\n  cmsBanners(first: 999) {\n    edges {\n      node {\n        id\n        title\n        link\n        homeBig\n        homeSmall\n      }\n    }\n  }\n  cmsCarouselImages(first: 999) {\n    edges {\n      node {\n        id\n        title\n        link\n        main1\n        main2\n        bg1\n        bg2\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2a242a85eee541fb06348b307adcdaf0';

module.exports = node;
